import React, { useEffect, useState } from 'react';
import { FaUserShield, FaSignOutAlt } from 'react-icons/fa';

function AdminBanner() {
  const [impersonating, setImpersonating] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const flag = localStorage.getItem('is_impersonating');
    const email = localStorage.getItem('impersonated_user_email');
    if (flag === 'true') {
      setImpersonating(true);
      setUserEmail(email || 'User');
    }
  }, []);

  const handleBackToAdmin = () => {
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken) {
      // ✅ Restore admin token
      localStorage.setItem('token', adminToken);

      // ✅ Clean up impersonation keys
      localStorage.removeItem('admin_token');
      localStorage.removeItem('is_impersonating');
      localStorage.removeItem('impersonated_user_email');

      window.location.href = '/'; // or wherever your admin dashboard is
    }
  };

  if (!impersonating) return null;

  return (
    <div
      className="hover:text-[#ed7b00] flex items-center text-[10px] text-[#434a57] font-semibold gap-2 cursor-pointer mt-3 dark:text-[#fff]"
      onClick={handleBackToAdmin}
      style={{
        pointerEvents: 'auto',
        background: 'white',
        borderRadius: '0.5em',
        
        marginTop: 8,
        marginBottom: 8,
        maxWidth: 240,
      }}
    >
      <FaSignOutAlt className="text-[14px]" />
      <span className="font-semibold">Back to Admin</span>
    </div>
  );
}

export default AdminBanner;